import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/emoji.png'


const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "right-wrap" }
const _hoisted_3 = { class: "main-content" }
const _hoisted_4 = { class: "tab-nav" }
const _hoisted_5 = { class: "leftitem" }
const _hoisted_6 = { class: "content-tabs" }
const _hoisted_7 = {
  key: 0,
  class: "tab-pane"
}
const _hoisted_8 = { class: "article-list" }
const _hoisted_9 = { class: "article-content" }
const _hoisted_10 = {
  key: 0,
  class: "audit-fail"
}
const _hoisted_11 = {
  key: 1,
  class: "audit-ing"
}
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "article-meta" }
const _hoisted_14 = { class: "article-actions" }
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "article-creator pagination" }
const _hoisted_17 = {
  key: 0,
  class: "infor-list"
}
const _hoisted_18 = {
  key: 1,
  class: "tab-pane"
}
const _hoisted_19 = { class: "article-list" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "article-meta" }
const _hoisted_22 = { class: "article-actions" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "article-creator pagination" }
const _hoisted_25 = {
  key: 0,
  class: "infor-list"
}

import { ref, onMounted, reactive } from "vue";
import { ElMessage } from "element-plus";

import CreatorHeader from "@/components/CreatorHeader.vue";
import axiosInstance from "@/utils/axiosInstance";
import { WebSite_Name } from "@/interface/globalindex";

import { useHead } from "@vueuse/head";

const formLabelWidth = "83px";

// 定义当前选中的标签，初始值为 'all'
interface ArticleInfo {
  article_id: string;
  title: string;
  created_at: string;
  audit_status: number;
}
interface UserProfile {
  request_id: string;
  user_id: string;
  created_at: string;
  old_user_name: string;
  new_user_name: string;
  old_company: string;
  new_company: string;
  old_job_title: string;
  new_job_title: string;
  old_blog_address: string;
  new_blog_address: string;
  old_description: string;
  new_description: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ArticleReviewList',
  setup(__props) {

const SSRData = ref({
  title: "内容审核 - 创作者中心 - " + WebSite_Name,
  description:
    "默认代码,defaultcode.com 是宁波的开发者技术社区，为开发者提供纯粹、高质的技术交流平台，让有意思的人聚在一起。",
  keywords:
    "默认代码,默认代码社区,宁波技术社区,宁波开发者技术交流社区,程序员中文技术社区",
});

// 使用组合式 API 设置 head
useHead({
  title: SSRData.value.title,
  meta: [
    { name: "description", content: SSRData.value.description },
    { name: "keywords", content: SSRData.value.keywords },
  ],
});
const activeTab = ref<string>("all");
const QueryTitle = ref("");

//正式发布
const articleinfo = ref<ArticleInfo[]>([]);

const currentPage = ref(1);
const pageSize = ref(10);
const total = ref(0);
const dialogFormVisible = ref(false);

// 获取等审核文章信息列表
const fetchArticleInfoAuditData = async () => {
  try {
    const response = await axiosInstance.get(
      "/api/EditorialCheckList/ArticleInfoAuditList",
      {
        params: {
          page: currentPage.value,
          querytitle: QueryTitle.value,
        },
      }
    );
    var result = response.data;
    if (result.success) {
      articleinfo.value = result.data.data;
      total.value = result.data.dataCount;
    }
  } catch (error) {
    console.error("fail:", error);
  }
};

// 当前页变化处理
const handleCurrentChange = (newPage: number) => {
  currentPage.value = newPage;
  fetchArticleInfoAuditData();
};

onMounted(() => {
  fetchArticleInfoAuditData();
});

//
const activeTabClick = () => {
  currentPage.value = 1;
  if (activeTab.value == "all") {
    fetchArticleInfoAuditData();
  } else {
    fetchUserChangeRequestData();
  }
};

// 用户个人资料审核
const userprofileList = ref<UserProfile[]>([]);

const fetchUserChangeRequestData = async () => {
  try {
    const response = await axiosInstance.get(
      "/api/EditorialCheckList/UserChangeRequestAuditList",
      {
        params: {
          page: currentPage.value,
        },
      }
    );
    var result = response.data;
    if (result.success) {
      userprofileList.value = result.data.data;
      total.value = result.data.dataCount;
    }
  } catch (error) {
    console.error("fail:", error);
  }
};
// 当前页变化处理
const handleUserChangeRequestChange = (newPage: number) => {
  currentPage.value = newPage;
  fetchUserChangeRequestData();
};

const form = reactive<UserProfile>({
  request_id: "",
  user_id: "",
  created_at: "",
  old_user_name: "",
  new_user_name: "",
  old_company: "",
  new_company: "",
  old_job_title: "",
  new_job_title: "",
  old_blog_address: "",
  new_blog_address: "",
  old_description: "",
  new_description: "",
});

//查询详情
const profiledetail = (itemdetail: UserProfile) => {
  form.request_id = itemdetail.request_id;
  form.user_id = itemdetail.user_id;
  form.old_user_name = itemdetail.old_user_name;
  form.new_user_name = itemdetail.new_user_name;
  form.old_job_title = itemdetail.old_job_title;
  form.new_job_title = itemdetail.new_job_title;
  form.old_company = itemdetail.old_company;
  form.new_company = itemdetail.new_company;

  form.old_blog_address = itemdetail.old_blog_address;
  form.new_blog_address = itemdetail.new_blog_address;
  form.old_description = itemdetail.old_description;
  form.new_description = itemdetail.new_description;
  dialogFormVisible.value = true;
};

// 审核通过
const AuditPassUserChangeRequest = (myrequest_id: String) => {
  let params = {
    request_id:myrequest_id
  }
  axiosInstance.post("api/EditorialCheckList/AuditPassUserChangeRequest", params).then((res) => {
    var result = res.data;
    if (result.success) {
      ElMessage.success('审核通过成功')
      dialogFormVisible.value = false;
      fetchUserChangeRequestData()
    }
  });
};
// 审核不通过
const AuditFailUserChangeRequest = (myrequest_id: String) => {
  let params = {
    request_id:myrequest_id
  }
  axiosInstance.post("api/EditorialCheckList/AuditFailUserChangeRequest", params).then((res) => {
    var result = res.data;
    if (result.success) {
      ElMessage.success('审核不通过')
      dialogFormVisible.value = false;
      fetchUserChangeRequestData()
    }
  });
};

return (_ctx: any,_cache: any) => {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_MoreFilled = _resolveComponent("MoreFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, { class: "creator-center" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_header, { class: "header" }, {
        default: _withCtx(() => [
          _createVNode(CreatorHeader)
        ]),
        _: 1
      }),
      _createVNode(_component_el_container, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_el_tabs, {
                      onTabClick: activeTabClick,
                      modelValue: activeTab.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_tab_pane, {
                          label: "内容审核",
                          name: "all",
                          style: {"font-size":"18px"}
                        }),
                        _createVNode(_component_el_tab_pane, {
                          label: "个人资料审核",
                          name: "profile"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _cache[8] || (_cache[8] = _createElementVNode("div", { class: "rightitem" }, null, -1))
                ]),
                _createElementVNode("div", _hoisted_6, [
                  (activeTab.value === 'all')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_8, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(articleinfo.value, (infoitem) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "article-item",
                                key: infoitem.article_id
                              }, [
                                _createElementVNode("div", _hoisted_9, [
                                  (infoitem.audit_status == 1)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, " 未通过 "))
                                    : _createCommentVNode("", true),
                                  (infoitem.audit_status == 2)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, " 待审核 "))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("a", {
                                    href: `/postreview/article/${infoitem.article_id}`,
                                    target: "_blank"
                                  }, [
                                    _createElementVNode("h3", null, _toDisplayString(infoitem.title), 1)
                                  ], 8, _hoisted_12),
                                  _createElementVNode("div", _hoisted_13, [
                                    _createElementVNode("span", null, _toDisplayString(infoitem.author) + "   " + _toDisplayString(infoitem.category_name) + "    " + _toDisplayString(infoitem.created_at), 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_14, [
                                  _createVNode(_component_el_dropdown, null, {
                                    dropdown: _withCtx(() => [
                                      _createVNode(_component_el_dropdown_menu, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_dropdown_item, null, {
                                            default: _withCtx(() => [
                                              _createElementVNode("a", {
                                                href: `/postreview/article/${infoitem.article_id}`,
                                                target: "_blank"
                                              }, "审核", 8, _hoisted_15)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_button, { text: "" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_icon, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_MoreFilled)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1024)
                                ])
                              ]))
                            }), 128)),
                            _createElementVNode("div", _hoisted_16, [
                              _createVNode(_component_el_pagination, {
                                background: "",
                                "hide-on-single-page": true,
                                layout: "prev, pager, next",
                                "current-page": currentPage.value,
                                "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((currentPage).value = $event)),
                                "page-size": pageSize.value,
                                "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((pageSize).value = $event)),
                                total: total.value,
                                onCurrentChange: handleCurrentChange
                              }, null, 8, ["current-page", "page-size", "total"])
                            ]),
                            (total.value == 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_17, _cache[9] || (_cache[9] = [
                                  _createElementVNode("div", { class: "content-flag" }, [
                                    _createElementVNode("div", { class: "common-empty" }, [
                                      _createElementVNode("img", { src: _imports_0 })
                                    ]),
                                    _createElementVNode("div", { class: "emoji-empty" }, "连emoji都选择微笑的空白区")
                                  ], -1)
                                ])))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (activeTab.value === 'profile')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userprofileList.value, (profileitem) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "article-item",
                              key: profileitem.request_id
                            }, [
                              _createElementVNode("div", {
                                class: "article-content",
                                onClick: ($event: any) => (profiledetail(profileitem))
                              }, [
                                _createElementVNode("h3", null, _toDisplayString(profileitem.old_user_name), 1),
                                _createElementVNode("div", _hoisted_21, [
                                  _createElementVNode("span", null, _toDisplayString(profileitem.created_at), 1)
                                ])
                              ], 8, _hoisted_20),
                              _createElementVNode("div", _hoisted_22, [
                                _createVNode(_component_el_dropdown, null, {
                                  dropdown: _withCtx(() => [
                                    _createVNode(_component_el_dropdown_menu, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_dropdown_item, null, {
                                          default: _withCtx(() => [
                                            _createElementVNode("a", {
                                              onClick: ($event: any) => (profiledetail(profileitem)),
                                              target: "_blank"
                                            }, "操作", 8, _hoisted_23)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_button, { text: "" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_icon, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_MoreFilled)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 2
                                }, 1024)
                              ])
                            ]))
                          }), 128)),
                          _createElementVNode("div", _hoisted_24, [
                            _createVNode(_component_el_pagination, {
                              background: "",
                              "hide-on-single-page": true,
                              layout: "prev, pager, next",
                              "current-page": currentPage.value,
                              "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => ((currentPage).value = $event)),
                              "page-size": pageSize.value,
                              "onUpdate:pageSize": _cache[4] || (_cache[4] = ($event: any) => ((pageSize).value = $event)),
                              total: total.value,
                              onCurrentChange: handleUserChangeRequestChange
                            }, null, 8, ["current-page", "page-size", "total"])
                          ]),
                          (total.value == 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, _cache[10] || (_cache[10] = [
                                _createElementVNode("div", { class: "content-flag" }, [
                                  _createElementVNode("div", { class: "common-empty" }, [
                                    _createElementVNode("img", { src: _imports_0 })
                                  ]),
                                  _createElementVNode("div", { class: "emoji-empty" }, "连emoji都选择微笑的空白区")
                                ], -1)
                              ])))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode(_component_el_dialog, {
                          modelValue: dialogFormVisible.value,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((dialogFormVisible).value = $event)),
                          title: "个人资料",
                          width: "580"
                        }, {
                          default: _withCtx(() => [
                            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "plusdivider" }, null, -1)),
                            _createVNode(_component_el_form, { ref: "ruleFormRef" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                  label: "旧用户名",
                                  "label-width": formLabelWidth,
                                  prop: "category_id"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(form.old_user_name), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                  label: "新用户名",
                                  "label-width": formLabelWidth,
                                  prop: "category_id"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(form.new_user_name), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                  label: "旧职位",
                                  "label-width": formLabelWidth,
                                  prop: "category_id"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(form.old_job_title), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                  label: "新职位",
                                  "label-width": formLabelWidth,
                                  prop: "category_id"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(form.new_job_title), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                  label: "旧公司",
                                  "label-width": formLabelWidth,
                                  prop: "category_id"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(form.old_company), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                  label: "新公司",
                                  "label-width": formLabelWidth,
                                  prop: "category_id"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(form.new_company), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                  label: "旧个人主页",
                                  "label-width": formLabelWidth,
                                  prop: "category_id"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(form.old_blog_address), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                  label: "新个人主页",
                                  "label-width": formLabelWidth,
                                  prop: "category_id"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(form.new_blog_address), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                  label: "旧个人介绍",
                                  "label-width": formLabelWidth,
                                  prop: "category_id"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(form.old_description), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                  label: "新个人介绍",
                                  "label-width": formLabelWidth,
                                  prop: "category_id"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(form.new_description), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, { class: "button-group-right" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_button, {
                                      type: "primary",
                                      onClick: _cache[5] || (_cache[5] = ($event: any) => (AuditPassUserChangeRequest(form.request_id)))
                                    }, {
                                      default: _withCtx(() => _cache[11] || (_cache[11] = [
                                        _createTextVNode(" 通过 ")
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_button, {
                                      type: "danger",
                                      onClick: _cache[6] || (_cache[6] = ($event: any) => (AuditFailUserChangeRequest(form.request_id)))
                                    }, {
                                      default: _withCtx(() => _cache[12] || (_cache[12] = [
                                        _createTextVNode(" 不通过 ")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 512)
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})